<script setup lang="ts">
import { computed } from 'vue';
import type { StyleValue } from 'vue';

import { getCssCustomPropertyValue } from '../../../helpers/cssCustomProperties';

import type {
  AppFlickerBorderRadius,
  AppFlickerSize,
  AppFlickerMargin,
  AppFlickerType,
} from './AppFlicker.model';

export interface AppFlickerProps {
  width: AppFlickerSize;
  height: AppFlickerSize;
  borderRadius?: AppFlickerBorderRadius;
  type?: AppFlickerType;
  margin?: AppFlickerMargin;
}

const props = withDefaults(defineProps<AppFlickerProps>(), {
  borderRadius: 'border-radius-8',
  type: 'secondary',
});

const style = computed<StyleValue>(() => {
  const width =
    props.width === '100%' || props.width === '50%'
      ? props.width
      : getCssCustomPropertyValue(props.width);
  const height =
    props.height === '100%' || props.height === '50%'
      ? props.height
      : getCssCustomPropertyValue(props.height);
  const borderRadius =
    props.borderRadius === '0'
      ? props.borderRadius
      : getCssCustomPropertyValue(props.borderRadius);

  let margin: string | undefined = undefined;
  if (props.margin) {
    const xSpacing =
      'xSpacing' in props.margin
        ? getCssCustomPropertyValue(props.margin.xSpacing)
        : undefined;
    const ySpacing =
      'ySpacing' in props.margin
        ? getCssCustomPropertyValue(props.margin.ySpacing)
        : undefined;

    margin = `${ySpacing ?? '0'} ${xSpacing ?? '0'} `;
  }

  return { width, height, 'border-radius': borderRadius, margin };
});
</script>

<template>
  <div :class="['app-flicker', [props.type]]" :style="style" />
</template>

<style scoped lang="scss">
@import '../../../styles/_mixins.scss';

.app-flicker {
  &.secondary {
    @include animated-background-secondary;
  }

  &.primary {
    @include animated-background-primary;
  }
}
</style>
